module.exports = __webpack_public_path__ + "img/dhht-2.7b6690f7.png";